import {currentLoginInfo} from "../../login/LoginPresenter";

export class ApprovalAndNotificationOverrider {
    constructor() {
    }

    overrideCriteria(criteria) {
        return criteria;
    }

    overrideQuestionFields(questionFields, source) {
        if (!questionFields)
            questionFields = [];
        let employee = find("employee", questionFields);
        if (!employee) {
            employee = {"id": "employee"};
            questionFields.push(employee);
        }
        let employee2 = currentLoginInfo().userInfo.employee;
        let employeeId = "";
        if (employee2)
            employeeId = employee2.id;
        employee.value = employeeId;
        let user = find("userId", questionFields);
        if (!user) {
            user = {"id": "userId"};
            questionFields.push(user);
        }
        let user2 = currentLoginInfo().userInfo;
        let userId = "";
        if (user2)
            userId = user2.id;
        user.value = userId;
        return questionFields;
    }
}